import { runningLocally } from "utils/constants";

export interface IImageResizeServiceOptions {
  width?: number | undefined;
  height?: number | undefined 
  quality?: number | undefined;
  /** A cache bust parameter */
  v?: string | undefined;
}

/** Uses the Daymade image resize to resize images. The Daymade image resize service uses a lambda. The code is located
 * here:
 * 
 * https://github.com/DAYMADEUK/lambda-image-transformer
 * 
*/
export function resizeImageUrl(imageUrl: string, options: IImageResizeServiceOptions) {
  let resizeImagePath = imageUrl.replace(
    'https://prize-assets.daymade.co.uk/',
    // The production environment's image resize service. We don't have a need for a non-prod version right now, as all
    // environments use the same prize-assets S3 bucket
    'https://images.daymade.co.uk/prize-assets/'
  );

  // If the image we are resizing isn't on the allow list, then don't attempt to use the image resizing service
  if (resizeImagePath.length == imageUrl.length) {
    // The image URL didn't change, don't use image resizing service
    return imageUrl;
  }
  
  let queryString = '';
  for (const key in options) {
    const value = options[key as keyof IImageResizeServiceOptions];
    if (value != undefined) {
      queryString += '&' + key + '=' + value;
    }
  }
  
  if (queryString) {
    return resizeImagePath + '?' + queryString.substring(1);
  }

  return resizeImagePath;
}